// ハンバーガーメニュー
document.addEventListener('DOMContentLoaded', function() {
  const hamburgerMenu = document.getElementById('hamburgerMenu');
  const filter = document.getElementById('js_filter');
  const footer = document.querySelector('.footer-cta-area'); 
  const main = document.querySelector('main');
  if (hamburgerMenu && filter) {
      hamburgerMenu.addEventListener('click', function() {
          const hamburger = this.querySelector('.hamburger');
          hamburger.classList.toggle('is-open');
          this.classList.toggle('is-open');
          
          if (this.classList.contains('is-open')) {
              filter.classList.add('is-open');
              footer.classList.add('is-hidden');
              main.classList.add('hidden');
          } else {
              filter.classList.remove('is-open');
              footer.classList.remove('is-hidden');
              main.classList.remove('hidden');
          }
      });
  } else {
      if (!hamburgerMenu) {
          console.error('Element with ID "hamburgerMenu" not found.');
      }
      if (!filter) {
          console.error('Element with ID "js_filter" not found.');
      }
  }
});

const hamburger = document.getElementById('hamburgerMenu');

window.addEventListener('scroll', () => {
  if (window.scrollY > 0) {
    hamburger.classList.add('is-scrolled');
  } else {
    hamburger.classList.remove('is-scrolled');
  }
});

//グローバルメニュー
document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll('.hasChild');

  triggers.forEach((trigger) => {
    const childMenu = trigger.querySelector('.child-menu');
    if (!childMenu) return;

    let hideTimer = null;

    const showMenu = () => {
      clearTimeout(hideTimer);
      childMenu.classList.add('is-visible');
    };

    const hideMenu = () => {
      // 少し遅延させることで、カーソル移動中にメニューが消えるのを防ぐ
      hideTimer = setTimeout(() => {
        childMenu.classList.remove('is-visible');
      }, 100);
    };

    // トリガー要素（親メニュー）
    trigger.addEventListener('mouseenter', showMenu);
    trigger.addEventListener('mouseleave', hideMenu);

    // チャイルドメニュー本体
    childMenu.addEventListener('mouseenter', showMenu);
    childMenu.addEventListener('mouseleave', hideMenu);
  });
});

//アコーディオン
// document.addEventListener("DOMContentLoaded", function() {
//   const menuTitles = document.querySelectorAll("#js_filter .menu-title.hasChild");


//   menuTitles.forEach((menuTitle) => {
//     menuTitle.addEventListener("click", function(e) {
//       if (e.target.tagName === 'A') return;
//       e.preventDefault();
//       if (window.innerWidth > 1024) return;
//       const childNav = menuTitle.nextElementSibling;


//       if (childNav) {
//         if (childNav.style.height && childNav.style.height !== "0px") {
//           childNav.style.height = childNav.scrollHeight + "px";
//           requestAnimationFrame(() => {
//             childNav.style.height = "0px";
//           });
//         } else {
//           childNav.style.height = "0px";
//           requestAnimationFrame(() => {
//             childNav.style.height = childNav.scrollHeight + "px";
//           });
//         }
//         menuTitle.classList.toggle("open");
//         childNav.classList.toggle("open");
//       }
//     });
//   });
// });
document.addEventListener("DOMContentLoaded", function() {
  const menuTitles = document.querySelectorAll("#js_filter .menu-title.hasChild");

  menuTitles.forEach((menuTitle) => {
    menuTitle.addEventListener("click", function(e) {
      if (window.innerWidth > 1024) return; // PC: aタグリンクを通す・アコーディオンOFF

      // SP: aタグも含めてリンクをブロック
      e.preventDefault();

      const childNav = menuTitle.nextElementSibling;

      if (childNav) {
        if (childNav.style.height && childNav.style.height !== "0px") {
          childNav.style.height = childNav.scrollHeight + "px";
          requestAnimationFrame(() => {
            childNav.style.height = "0px";
          });
        } else {
          childNav.style.height = "0px";
          requestAnimationFrame(() => {
            childNav.style.height = childNav.scrollHeight + "px";
          });
        }
        menuTitle.classList.toggle("open");
        childNav.classList.toggle("open");
      }
    });
  });
});

//cta固定
document.addEventListener('DOMContentLoaded', function() {
  const footer = document.querySelector('.footer-cta-area');
  window.addEventListener('scroll', function() {
    if (window.scrollY > 500) {
      footer.classList.add('footer-cta-scrolled');
    } else {
      footer.classList.remove('footer-cta-scrolled');
    }
  });
});
// go-top
document.addEventListener('DOMContentLoaded', function() {
  const goTopBtn = document.querySelector('.go-top');
  if (goTopBtn) {
    goTopBtn.addEventListener('click', function(event) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
});
// 初期状態で画面内にある要素にも適用
document.addEventListener('DOMContentLoaded', function() {
  const fadeinElements = document.querySelectorAll('.fadein');
  
  fadeinElements.forEach(function(elem) {
    const elemPos = elem.getBoundingClientRect().top + window.pageYOffset;
    const scroll = window.pageYOffset;
    const windowHeight = window.innerHeight;

    if (scroll > elemPos - windowHeight) {
      elem.classList.add('is-active');
    }
  });
});


// fadein is-active を付与する共通関数
function handleFadein(selector) {
  const elements = document.querySelectorAll(`${selector}:not(.is-active)`);
  const scroll = window.pageYOffset;
  const windowHeight = window.innerHeight;

  elements.forEach(function(elem) {
    const elemPos = elem.getBoundingClientRect().top + window.pageYOffset;
    if (scroll > elemPos - windowHeight) {
      elem.classList.add('is-active');
    }
  });
}

// 対象セレクター
const fadeinSelectors = [
  '.fadein',
  '.fadein-before',
  '.fadein-after',
  '.zoomin',
];

function runFadein() {
  fadeinSelectors.forEach(function(selector) {
    handleFadein(selector);
  });
}

// スクロール時・読み込み時に実行
window.addEventListener('scroll', runFadein);
window.addEventListener('DOMContentLoaded', runFadein);


// 一覧カテゴリフィルター
document.querySelectorAll('.filter-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const active = btn.classList.toggle('is-active');
    btn.setAttribute('aria-pressed', active);

    const tag = btn.dataset.tag;
    console.log(`Tag: ${tag} → ${active ? 'ON' : 'OFF'}`);
  });
});